import { components } from "@/api-schema";
import { Action, MergeEntityName } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { ModelFamilyTable } from "@/components/data-table/predefined/model-family-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { getModelFamilyMergeLabel } from "@/components/merge/_helpers/model-merge-labels";
import { MergeDialog } from "@/components/merge/merge-dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;
type ModelFamily = components["schemas"]["ModelFamily"];

export function ModelFamilyView() {
  const { t } = useTranslation(["common", "masterdata"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "ModelFamily");
  const canMerge = ability.can(Action.Merge, "ModelFamily");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
      };
  const [mergingModelFamily, setMergingModelFamily] = useState<ModelFamily | null>(null);

  return (
    <Can I="read" a="ModelFamily">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("common:ModelFamilies")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <ModelFamilyTable
          body={{}}
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onMerge={canMerge ? setMergingModelFamily : undefined}
        />
      </CenteredLayout>

      {mergingModelFamily && (
        <MergeDialog
          open={true}
          entity={MergeEntityName.ModelFamily}
          source={{ uuid: mergingModelFamily.uuid, label: getModelFamilyMergeLabel(mergingModelFamily) }}
          onClose={() => setMergingModelFamily(null)}
        />
      )}
    </Can>
  );
}
